import { render, staticRenderFns } from "./WeeklyReportDetail.vue?vue&type=template&id=66a808c1&scoped=true&"
import script from "./WeeklyReportDetail.vue?vue&type=script&lang=js&"
export * from "./WeeklyReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyReportDetail.vue?vue&type=style&index=0&id=66a808c1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a808c1",
  null
  
)

export default component.exports